import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const scrollToSection = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

const Navbar = () => {
  const [nav, setNav] = useState(true);

  const handleNav = () => {
    setNav(!nav);
  };

  const handleMobileNavClick = (id: string) => {
    scrollToSection(id);
    setNav(true);
  };

  return (
    <div className="flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white border-b-4 border-gray-900">

      <h1 className="w-full text-3xl font-bold text-[#00df9a]">Marcin De.</h1>
      <ul className="hidden md:flex">
        <li className="p-4 hover:underline" onClick={() => scrollToSection('home')}>Home</li>
        <li className="p-4 hover:underline" onClick={() => scrollToSection('about')}>About</li>
        <li className="p-4 hover:underline" onClick={() => scrollToSection('projects')}>Projects</li>
        <li className="p-4 hover:underline" onClick={() => scrollToSection('contact')}>Contact</li>
      </ul>
      <div
        onClick={handleNav}
        className="text-3xl cursor-pointer block md:hidden"
      >
        {nav ? <AiOutlineMenu /> : <AiOutlineClose />}
      </div>
      <div
        className={
          !nav
            ? "fixed right-0 top-24 w-[50%] border-l-4 border-l-gray-900 bg-[#000300] h-full ease-in-out duration-500"
            : "fixed right-[-100%]"
        }
      >
        <ul className="pt-12 uppercase p-4">
          <li className="p-4 border-b border-gray-600 hover:underline" onClick={() => handleMobileNavClick('home')}>Home</li>
          <li className="p-4 border-b border-gray-600 hover:underline" onClick={() => handleMobileNavClick('about')}>About</li>
          <li className="p-4 border-b border-gray-600 hover:underline" onClick={() => handleMobileNavClick('projects')}>Projects</li>
          <li className="p-4 border-b border-gray-600 hover:underline" onClick={() => handleMobileNavClick('contact')}>Contact</li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
